import { RefObject } from 'react';
import AssetsSelectedPopover from '../../tooltips/assets-selected-popover/AssetsSelectedPopover';
import * as L from 'leaflet';
import BasicTooltip from '../../tooltips/basic-tooltip/BasicTooltip';
import { ObjectType } from '@dmc/ui';
import { useObjectTypeMarkerIcon } from '../useObjectTypeMarkerIcon';
import { useObjectMarkerTooltipOffset } from '../useObjectMarkerTooltipOffset';
import RotatableClusterMarker from '../rotatable-cluster-marker/RotatableClusterMarker';
import { AssetMarkerProps } from '../asset-marker/AssetMarker';

export interface AssetTablePositionMarkerProps extends AssetMarkerProps {
  onClick: () => void;
  isSelected: boolean;
  clusterGroupRef: RefObject<L.MarkerClusterGroup>;
}

export function AssetTablePositionMarker({
  position,
  heading,
  obj,
  label,
  onClick,
  isSelected,
  id,
  clusterGroupRef,
}: AssetTablePositionMarkerProps) {
  const { height, width, icon } = useObjectTypeMarkerIcon(obj);

  const offset = useObjectMarkerTooltipOffset({
    heading,
    width,
    height,
    isSvgObjectTypeIcon: obj !== ObjectType.Unknown,
  });

  return (
    <RotatableClusterMarker
      key={`${id}-${isSelected}`}
      icon={icon}
      position={position}
      heading={heading}
      isSelected={isSelected}
      clusterGroupRef={clusterGroupRef}
      eventHandlers={
        onClick
          ? {
              click: () => onClick(),
            }
          : undefined
      }
    >
      <BasicTooltip permanent={true} interactive={true} text={label} offset={offset} />
      {isSelected && <AssetsSelectedPopover id={id} label={label} />}
    </RotatableClusterMarker>
  );
}

export default AssetTablePositionMarker;
